import { render, staticRenderFns } from "./productawardList.vue?vue&type=template&id=9399146e&scoped=true"
import script from "./productawardList.vue?vue&type=script&lang=js"
export * from "./productawardList.vue?vue&type=script&lang=js"
import style0 from "./productawardList.vue?vue&type=style&index=0&id=9399146e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9399146e",
  null
  
)

export default component.exports